var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddressDelete = function SvgAddressDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#AddressDelete_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    fillRule: "evenodd",
    d: "M6.667 3.333c0-.368.298-.666.666-.666h5.334a.667.667 0 1 1 0 1.333H7.333a.667.667 0 0 1-.666-.667M2.667 6c0-.368.298-.667.666-.667h13.334a.667.667 0 1 1 0 1.334h-.707l-.472 7.54a3.333 3.333 0 0 1-3.326 3.126H7.839a3.333 3.333 0 0 1-3.327-3.125L4.04 6.667h-.707A.667.667 0 0 1 2.667 6m2.71.667.466 7.458A2 2 0 0 0 7.839 16h4.323a2 2 0 0 0 1.996-1.875l.466-7.458zm3.29 2.666c.368 0 .666.299.666.667v2.667a.667.667 0 1 1-1.333 0V10c0-.368.299-.667.667-.667M12 10a.667.667 0 0 0-1.333 0v2.667a.667.667 0 0 0 1.333 0z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "AddressDelete_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2 2h16v16H2z"
  })))));
};
export default SvgAddressDelete;